import {
    MemoDetailApiV1AdjutantAppMemoMemoIdGetParams,
    MemoDetailShareApiV1AdjutantAppMemoMemoIdShareGetParams,
    MemoDTO,
    MemoListApiV1AdjutantAppMemoGetParams,
    MemoListOutputDTO,
    MemoPromptListApiV1AdjutantAppMemoPromptGetParams,
    MemoPromptListOutputDTO,
    MemoPublicDTO,
    MemoUpdateApiV1AdjutantAppMemoMemoIdPutParams,
    MemoUpdateModel,
} from '../swagger/dto'
import { getRequest, getRequestWithParseParams, putRequest } from './config'
import { MEMO_PROMPT_URL, MEMO_URL } from './endpoints.constants'

export const getMemoList = async (params: MemoListApiV1AdjutantAppMemoGetParams) => {
    const response = await getRequest<MemoListOutputDTO>(MEMO_URL, params)
    return response.data
}

export const getMemoDetail = async (params: MemoDetailApiV1AdjutantAppMemoMemoIdGetParams) => {
    const response = await getRequest<MemoDTO>(`${MEMO_URL}/${params.memoId}`)

    return response.data
}

export const getMemoPrompt = async (params: MemoPromptListApiV1AdjutantAppMemoPromptGetParams) => {
    const response = await getRequestWithParseParams<MemoPromptListOutputDTO>(
        `${MEMO_PROMPT_URL}`,
        params,
    )
    return response.data
}

export const getMemoShare = async (
    params: MemoDetailShareApiV1AdjutantAppMemoMemoIdShareGetParams,
) => {
    const response = await getRequest<MemoPublicDTO>(`${MEMO_URL}/${params.memoId}/share`)

    return response.data
}

export const putMemo = async (
    params: MemoUpdateApiV1AdjutantAppMemoMemoIdPutParams,
    payload: MemoUpdateModel,
) => {
    const response = await putRequest<MemoUpdateModel>(`${MEMO_URL}/${params.memoId}`, payload)
    return response.data
}
